import { render, staticRenderFns } from "./NumberOutput.vue?vue&type=template&id=20e80fbd&scoped=true"
import script from "./NumberOutput.vue?vue&type=script&lang=ts"
export * from "./NumberOutput.vue?vue&type=script&lang=ts"
import style0 from "./NumberOutput.vue?vue&type=style&index=0&id=20e80fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e80fbd",
  null
  
)

export default component.exports